package com.patronat.top.client.domain.reviews

import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewListResponse

data class GetClientMyReviewsCommand(
    val page: Int = 1,
    val pageSize: Int = 50
)

class GetClientMyReviewsUseCase(
    private val repository: ClientReviewsRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetClientMyReviewsCommand, DomainResult<ReviewListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetClientMyReviewsCommand): DomainResult<ReviewListResponse> {
        return repository.getMyReviews(
            page = command.page,
            pageSize = command.pageSize
        )
    }
}
